var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import { default as BannerCarousel } from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { CHEVRON_LEFT_SVG } from "../assets/index";
import { useHistory } from "react-router";
import { useWindowSize } from "../hooks/useWindowResize";
var CustomRightArrow = function (_a) {
    var onClick = _a.onClick;
    return React.createElement("button", { className: "right-button", type: "button", onClick: onClick },
        React.createElement("img", { className: "right-arrow", src: CHEVRON_LEFT_SVG, alt: "left arrow" }));
};
var CustomLeftArrow = function (_a) {
    var onClick = _a.onClick;
    return React.createElement("button", { className: "left-button", type: "button", onClick: onClick },
        React.createElement("img", { className: "left-arrow", src: CHEVRON_LEFT_SVG, alt: "left arrow" }));
};
var responsive = {
    superLargeDesktop: {
        breakpoint: { max: 6000, min: 3000 },
        items: 1,
        partialVisibilityGutter: 320
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
        partialVisibilityGutter: 320
    },
    small_desktop: {
        breakpoint: { max: 1424, min: 650 },
        items: 1,
        partialVisibilityGutter: 100
    },
    tablet: {
        breakpoint: { max: 1024, min: 650 },
        items: 1,
        partialVisibilityGutter: 80
    },
    mobile: {
        breakpoint: { max: 650, min: 0 },
        items: 1,
        partialVisibilityGutter: 60
    }
};
var getCurrentBreakPoint = function (width) {
    return Object.keys(responsive).find(function (key) {
        if (responsive[key].breakpoint.min <= width && responsive[key].breakpoint.max >= width) {
            return true;
        }
        return false;
    });
};
var Carousel = function (props) {
    var history = useHistory();
    var size = useWindowSize();
    var _a = useState(getCurrentBreakPoint(size.width)), breakPoint = _a[0], setOldBreakPoint = _a[1];
    React.useEffect(function () {
        setOldBreakPoint(getCurrentBreakPoint(size.width));
    }, [size.width]);
    var CustomDot = function (_a) {
        var onClick = _a.onClick, rest = __rest(_a, ["onClick"]);
        var active = rest.active, index = rest.index;
        if (active) {
            return (React.createElement("div", { className: "indicator-wrapper no-select", style: { padding: '1rem' } },
                React.createElement("li", { className: "indicator" })));
        }
        return (React.createElement("div", { className: "indicator-wrapper no-select", onClick: onClick, onKeyDown: onClick, style: { padding: '1rem', cursor: 'pointer' } },
            React.createElement("li", { className: "indicator unselected", value: index, key: index, role: "button", tabIndex: 0 })));
    };
    var hasMultiple = props.banner.BannerImages.length > 1;
    return (React.createElement("div", { className: "Carousel " + (!hasMultiple ? 'single' : '') },
        React.createElement(BannerCarousel, { key: breakPoint, partialVisible: hasMultiple, responsive: responsive, customLeftArrow: React.createElement(CustomLeftArrow, null), customRightArrow: React.createElement(CustomRightArrow, null), renderDotsOutside: true, customDot: React.createElement(CustomDot, null), showDots: hasMultiple, keyBoardControl: hasMultiple, autoPlay: hasMultiple, infinite: hasMultiple, autoPlaySpeed: 5000, swipeable: hasMultiple, containerClass: 'carousel' }, props.banner.BannerImages.map(function (banner, i) {
            return (React.createElement("div", { className: "items-container " + (banner.link ? 'link' : ''), key: banner.id, onClick: function () {
                    props.onClick('banner', banner.id);
                    if (banner.link) {
                        if (banner.link.startsWith('https://')) {
                            window.open(banner.link, banner.link);
                        }
                        else {
                            history.push(banner.link);
                        }
                    }
                } }, (function () {
                var image = (breakPoint == 'mobile' && banner.image_url_small) ? banner.image_url_small : banner.image_url_large;
                if (banner.video_url_large) {
                    return React.createElement("video", { className: "card-image", poster: image, src: (breakPoint == 'mobile' && banner.video_url_small) ? banner.video_url_small : banner.video_url_large, playsInline: true, autoPlay: true, muted: true, loop: true });
                }
                else {
                    return React.createElement("img", { className: "card-image", src: image, alt: "banner" });
                }
            })()));
        }))));
};
export default Carousel;
//# sourceMappingURL=Carousel.js.map